import {Logger} from "./Logger";
import {BrowserUtils} from "./BrowserUtils";

export function FallbackCookieTrackingPlugin(fallbackCookie) {
    const browserUtils = BrowserUtils();
    let _logger = Logger();
    let _trackerInstance;

    function getSessionLessID() {
        return browserUtils.getCookieValue(fallbackCookie);
    }

    //implementation for methods from Snowplow BrowserPlugin interface
    return {
        activateBrowserPlugin: (tracker) => {
            _trackerInstance = tracker;
            _logger.debug("FallbackCookieTrackingPlugin activated on sp instance id and namespace ", tracker.id, tracker.namespace);
            _logger.debug("FallbackCookieTrackingPlugin activated with value ", getSessionLessID());
        },
        beforeTrack: (payloadBuilder) => {
            const fallbackID = getSessionLessID();
            payloadBuilder.add("duid", fallbackID);
            payloadBuilder.add("sid", fallbackID);
            _logger.debug("attached duid and sid: ", fallbackID);
        },
        logger: (logger) => _logger = logger,
        getSessionLessID: getSessionLessID
    }
}
